@if (navigable) {
  <a class="app-brand-link" [routerLink]="['/']" [attr.aria-label]="brandWordmark">
    <img
      [src]="brandLogoSrc"
      class="app-brand-logo app-brand-logo--light"
      alt=""
      aria-hidden="true"
    />
    <img
      [src]="brandLogoWhiteSrc"
      class="app-brand-logo app-brand-logo--dark"
      alt=""
      aria-hidden="true"
    />
  </a>
} @else {
  <span class="app-brand-link" [attr.aria-label]="brandWordmark">
    <img
      [src]="brandLogoSrc"
      class="app-brand-logo app-brand-logo--light"
      alt=""
      aria-hidden="true"
    />
    <img
      [src]="brandLogoWhiteSrc"
      class="app-brand-logo app-brand-logo--dark"
      alt=""
      aria-hidden="true"
    />
  </span>
}
